import React from "react";
import { v4 as uuidv4 } from "uuid";

interface SocialLink {
  href: string;
  icon: React.ReactNode;
}

interface SocialLinksProps {
  socials: SocialLink[];
}

const SocialLinks: React.FC<SocialLinksProps> = ({ socials }) => (
  <ul className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-3 w-full text-center">
    {socials.map((url) => (
      <li className="" key={uuidv4()}>
        <a href={url.href} target="_blank" rel="noreferrer">
          {url.icon}
        </a>
      </li>
    ))}
  </ul>
);

export default SocialLinks;
